import { Injectable } from '@angular/core';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { API_METHODS, API_URL, OperationType } from 'common/constants/sm-constants';
import { SystemService } from 'common/services/core-services/system.service';
import { editInfo } from 'common/models/utility-models/utility-interface';
import { environment } from 'src/environments/environment';
import { FormDataService } from '../../base-data-services/form-data.service';
import { CompletedPayload, StudentAssignmentDetailsModel } from 'common/models/page-models/Student Assignment/Student Assignment Details/student-assignment-details-data.model';
import moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class StudentAssignmentDetailsDataService extends FormDataService<StudentAssignmentDetailsModel> {
  constructor(http: SmApiService, protected override ss: SystemService) {
    super(API_URL.StudentAcceptedAssignment, http, ss);
  }
  
  override getEditUrlAndMethod(data) {
    let url;
    let method;
    // console.log(data.transferData.type);
    switch (data.transferData.type) {

        case "complete":
        case "completed":
            url = environment.apiUrl + API_URL.StudentAssignmentDetailsCompleted;
            method = API_METHODS.post;
            break;
        case "incomplete":
        case "incompleted":
            url = environment.apiUrl + API_URL.studentAssignmentDetailsInCompleted;
            method = API_METHODS.post;
            break;
        case "todo":
            url = environment.apiUrl + API_URL.StudentAssignmentDetailsToDo;
            method = API_METHODS.post;
            break;
        // case "upcomingassignment":
        case "upcoming":
            url = environment.apiUrl + API_URL.StudentAssignmentDetailsToDo;
            method = API_METHODS.post;
            break;
         
        default:
            console.error("Unsupported type:", data.transferData.type);
            return null;
    }

    const edit = {
        url: url,
        method: method,
    };

    return edit;
}

// upload Api  uploadTodoAssignment


  
  // override afterGetData(model: StudentAssignmentDetailsModel): Promise<StudentAssignmentDetailsModel> {
  //   return new Promise<any>((resolve, reject) => {

  
  //     // const submitData= new model
  //     // submitData.assignment_id=model.assignment_id;
  //     // submitData.timeslot_id =model.assignment_timeslot[0].id
  //     resolve(model)
  //   });
  // }

//   override modifyPostModel(formModel: any, dataModel: any) {



//     if(dataModel.pageKey=="upcomingassignment){
//       formModel['assignment_id'] = dataModel.id;
//       formModel['timeslot_id'] = dataModel.assignment_timeslot[0].id;
//     }

    
   
//     return formModel;
// }

// override modifyPostModel(formModel: any, dataModel: any) {
 

//   if (dataModel.pageKey === "upcoming" ||dataModel.pageKey === "upcomingassignment") {
//     formModel['assignment_id'] = dataModel.id;
//     if (dataModel.assignment_timeslot && dataModel.assignment_timeslot.length > 0) {
//       formModel['timeslot_id'] = dataModel.assignment_timeslot[0].id;
//     }
//     // return formModel;
//   }
//   if (dataModel.pageKey === "complete" ||dataModel.pageKey === "completed" ) {

//     formModel["assignment_id"] = dataModel.id;
//     formModel['student_ratings'] =dataModel.student_ratings;
//     formModel['studentfeedback'] = dataModel.studentfeedback
//     console.log(formModel);
    
//     // formModel['studentfeedback'] = dataModel.student_feedback


//   }
  

//   if (dataModel.pageKey === "todo") {
//     formModel["assignment_id"] = dataModel.id;
//     formModel['upload_assignment'] =dataModel.upload_assignment;
//     // return formModel;
//   }
//   return formModel;
  
// }

override modifyPostModel(formModel: any, dataModel: any) {
  
  // console.log(formModel,'formData');
  
  if (dataModel.pageKey === "upcoming" || dataModel.pageKey === "upcomingassignment") {
    formModel['assignment_id'] = dataModel.id;
    if (dataModel.assignment_timeslot && dataModel.assignment_timeslot.length > 0) {
      formModel['timeslot_id'] = dataModel.assignment_timeslot[0].id;
    }
    return formModel;
  }


  if (dataModel.pageKey === "complete" || dataModel.pageKey === "completed") {
    dataModel.student_feedback = formModel.student_feedback;
    const completeData = {
      assignment_id: dataModel.id,
      id: dataModel.id,
      pageKey:dataModel.pageKey,
      student_ratings: dataModel.student_ratings,
      student_feedback: dataModel.student_feedback};
    // console.log(completeData);
    return completeData;
  }

  // if (dataModel.pageKey === "todo") {

  //   const todoData = {
  //     assignment_id: dataModel.id,
  //     id: dataModel.id,
  //     pageKey:dataModel.pageKey,
  //     upload_assignment: dataModel.upload_assignment,
  //   };
  //   console.log(todoData);
  //   return todoData;


    // formModel["assignment_id"] = dataModel.id;
    // formModel['upload_assignment'] = dataModel.upload_assignment;
    // return formModel;
  // }

  
  if (dataModel.pageKey === "todo") {
    const formData = new FormData();

    formData.append('assignment_id', dataModel.id);
    formData.append('id', dataModel.id);
    formData.append('pageKey', dataModel.pageKey);
    
    if (dataModel.upload_assignment) {
      formData.append('upload_assignment', dataModel.upload_assignment);
    } else{
      this.ss.showError("Assignment Required. Please upload assignment");
      return;
    }

    // console.log('FormData for todo:', formData);
    return formData; 
  }

  return formModel;
}


  override getUpdateUrl(data) {
  //  console.log(data,'dataaaa')
    return API_URL.StudentAcceptedAssignment;
  }
  
  override updatepostUrl(type: OperationType, data=null) {

    // console.log(data,'test PageKy')
    
    if (data && data.pageKey === "complete" ||data.pageKey === "completed" ) {
        return environment.apiUrl + API_URL.AddStudentFeedbackInAssignment;
    // }else if (data.pageKey === "upcomingassignment") {
    }else if (data.pageKey === "upcoming" ||data.pageKey === "upcomingassignment") {

      return environment.apiUrl + API_URL.StudentAcceptedAssignment; 
    }
    else {
      return environment.apiUrl + API_URL.uploadTodoAssignment; 
  }
}

  createInstance(): StudentAssignmentDetailsModel {
    return new StudentAssignmentDetailsModel();
  }

  override getUpdatePayload(data) {
    let assignmentType: number;

    if (data.transferData.type === 'todo') {
      assignmentType = 1; 
    } else if (data.transferData.type === 'incomplete' || data.transferData.type === 'incompleted') {
      assignmentType = 2; 
    } else if (data.transferData.type === 'complete' || data.transferData.type === 'completed') {
      assignmentType = 3; 
    } else {
      assignmentType = 0; 
    }
    const payload = {
      id: data.transferData.id,
      assignmentType: assignmentType 
      
    };  
    return payload;
  }

  

  // override beforePostData(
  //   model: any,
  //   metamodel: any,
  //   dataModel: any
  // ): Promise<StudentAssignmentDetailsModel> {
  //   return new Promise<any>((resolve, reject) => {
  //       resolve(model);
  //     });
  // }

  // override generateUrl(type: OperationType, paramKey?: any, extraKey?: any, data?: any) {
  //   console.log(data,"data")
  //     return "";
  // }

  // override updatepostUrl(type: OperationType) {
  //     console.log("hello")
  //     return "";
  // }

  override beforeGetData(model: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      resolve(model);
    });
  }

  override modifyAPIResponse(response: any) {
    // console.log("response--- ", response)

    const returnData = this.customMerge(
      new StudentAssignmentDetailsModel(),
      response.details
    );
    returnData['docPath'] = response && 
                        response.details.assignment_uploaded_documents && 
                        response.details.assignment_uploaded_documents.length > 0 &&
                        response.details.file_url_path &&
                        response.details.assignment_uploaded_documents[0].document_path
    ? response.details.file_url_path + response.details.assignment_uploaded_documents[0].document_path 
    : "";

    returnData['docPathExpire'] = response && 
                        response.details.assignment_uploaded_docucments && 
                        response.details.assignment_uploaded_docucments.length > 0 &&
                        response.details.file_url_path &&
                        response.details.assignment_uploaded_docucments[0].document_path
    ? response.details.file_url_path + response.details.assignment_uploaded_docucments[0].document_path 
    : "";

    returnData['docAssignmetDownload'] = response &&
    response.details.assignment_uploaded_documents &&
    response.details.assignment_uploaded_documents.length > 0 &&
    response.details.student_doc_url_path &&
    response.details.assignment_details &&
    response.details.assignment_details.student_file_submit
    ? response.details.student_doc_url_path + response.details.assignment_details.student_file_submit
    : "";
    returnData['student_doc_url_path'] =
    response.details.student_doc_url_path;
    returnData['assignment_uploaded_docucments'] =
      response.details.assignment_uploaded_docucments;
      returnData['assignment_uploaded_documents'] =
      response.details.assignment_uploaded_documents; 
      returnData['assignment_timeslot'] =
      response.details.assignment_timeslot;  
      
      returnData['start_date'] = response && response.details?.start_date && moment.utc(response.details.start_date).format('DD/MM/YYYY hh:mm A') ;
      returnData['end_date'] = response && response.details?.end_date && moment.utc(response.details.end_date).format('DD/MM/YYYY hh:mm A');
      // console.log("RETURN DATA ", returnData)
      
    return returnData;
  }

  customMerge(obj1: object, obj2: object): any {
    const result: object = {};

    for (const key in obj1) {
      if (obj2.hasOwnProperty(key)) {
        if (obj1.hasOwnProperty(key)) {
        
          result[key] = obj2[key];
        }
      }
    }
    return result;
  }




}
